<template lang="html">
  <canvas class="speed-gauge"></canvas>
</template>

<script>
import { RadialGauge } from 'canvas-gauges'

export default {
  name: 'speed-gauge',
  props: {
    value: {
      type: Number,
      required: true
    }
  },
  data: function () {
    return {
      chart: {},
      options: {
        width: 250,
        height: 250,
        units: 'Km/h',
        title: 'Velocidad',
        minValue: 0,
        maxValue: 300,
        majorTicks: [
          '0', '20', '40', '60', '80', '100', '120', '140', '160', '180', '200', '220', '240', '260', '280', '300'
        ],
        minorTicks: 2,
        strokeTicks: true,
        highlights: [
          { from: 120, to: 300, color: 'rgba(200,50,50,.75)' }
        ],
        colorPlate: '#222',
        colorMajorTicks: '#f5f5f5',
        colorMinorTicks: '#ddd',
        colorTitle: '#fff',
        colorUnits: '#ccc',
        colorNumbers: '#eee',
        colorBorderOuter: '#333',
        colorBorderOuterEnd: '#111',
        colorBorderMiddle: '#222',
        colorBorderMiddleEnd: '#111',
        colorBorderInner: '#111',
        colorBorderInnerEnd: '#333',
        needleCircleSize: '7',
        colorNeedle: '#ff0000',
        colorNeedleEnd: '#ff0000',
        valueBox: true,
        valueBoxBorderRadius: 0,
        colorValueBoxRect: '#222',
        colorValueBoxRectEnd: '#333'
      }
    }
  },
  watch: {
    value: function (speed) {
      this.chart.value = speed
    }
  },
  mounted () {
    this.options.value = this.value
    this.options.renderTo = this.$el
    this.chart = new RadialGauge(this.options).draw()
  },
  beforeDestroy () {
    this.chart.destroy()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Gauges/Speed.vue